import { render } from "./InviteForm.vue?vue&type=template&id=407ff18b"
import script from "./InviteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/ss_user/components/InviteForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "407ff18b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('407ff18b', __exports__)) {
    api.reload('407ff18b', __exports__)
  }
  
  module.hot.accept("./InviteForm.vue?vue&type=template&id=407ff18b", () => {
    api.rerender('407ff18b', render)
  })

}


export default __exports__